import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";

type Author = {
  id: number;
  name: string;
  email: string;
};

interface ApplicationNote {
  id: number;
  author: Author;
  message: string;
  created_at: string;
  updated_at?: string;
}

export const notesQueryKey = (applicationId) => ["NOTES", applicationId];

export const useNotes = (applicationId: string) => {
  return useQuery<ApplicationNote[]>({
    queryKey: notesQueryKey(applicationId),
    queryFn: () =>
      instance
        .get(`portal/v1/boom_screen_applications/${applicationId}/notes`)
        .then(({ data }) => data?.notes),
    enabled: Boolean(applicationId && applicationId !== "undefined")
  });
};
